'use strict';

import 'document-register-element';
import resizeStore from '../resize/resize.store';

import Draggable from 'gsap/Draggable';
import {prefixedCSSValue} from '../utils';

const grabbing = prefixedCSSValue('cursor', 'grabbing');
const grab = prefixedCSSValue('cursor', 'grab');


export class Comparison extends HTMLElement {
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this._dragWidth = 1;
    this._dragElementWidth = 1;

    this.onResize = e => this._onResize(e);
    this.onUpdate = e => this._onUpdate(e);
  }
  connectedCallback() {
    this._dragElement = this.querySelector('.comparisonDragElement');
    this._items = Array.from(this.querySelectorAll('.comparisonItem'));
    this._inner = this.querySelector('.comparisonInner')

    this._draggable = Draggable.create(this._dragElement, {
      type: 'x',
      edgeResistance: 1,
      dragResistance: 0,
      bounds: this,
      throwProps: true,
      cursor: grab,
      activeCursor: grabbing,
      onDrag: this.onUpdate,
      onThrowUpdate: this.onUpdate
    })[0];

    const images = Array.from(this.querySelectorAll('img'));
    const promises = [];

    images.forEach(image => {
      const img = new Image();
      img.src = image.src;
      promises.push(new Promise(resolve => img.addEventListener('load', () => {
        resolve();
      })));
    })
    Promise.all(promises)
      .then(() => this._onResize())
      .catch(e => console.log(e))

    resizeStore.eventEmitter.subscribe(this.onResize);
  }
  disconnectedCallback() {
    resizeStore.eventEmitter.unsubscribe(this.onResize);
  }
  _onResize() {
    // const bounds = this.getBoundingClientRect();
    //
    // this._dragWidth = bounds.width;
    // this._dragElementWidth = this._dragWidth * 2;

    let width = 0;
    this.style.width = '';
    this._items.forEach(item => item.style.width = '');

    setTimeout(() => {
      const bounds = this.getBoundingClientRect();
      const maxWidth = bounds.width;

      this._items.forEach(item => {
        const itemBounds = item.getBoundingClientRect();
        width = Math.max(width, itemBounds.width)
      });
      width = Math.min(maxWidth, width);

      this.style.width = width + 'px';

      this._dragWidth = width;
      this._dragElementWidth = this._dragWidth * 2;

      this._items.forEach(item => item.style.width = width + 'px');

      this._onUpdate();
    }, 0)
  }

  _onUpdate(e) {
    const c = this._draggable.x / (this._dragElementWidth - this._dragWidth) + 0.5;

    this.style.setProperty('--comp', c.toString());
  }
}


window.customElements.define('comparison-view', Comparison);